import axios from 'axios';
import { BEPI_API } from '../config/bepiApiPaths';

const BASE_URL = BEPI_API.catalog;

/**
 * API compartilhada para seleção hierárquica: Categoria → Produto → Serviço.
 * Reutilizável entre Workshop, Client e Admin.
 */
export const CatalogHierarchyApi = {
  /**
   * Retorna todas as categorias.
   * GET /web/client/catalog/hierarchy/categorias
   */
  getCategorias: () => axios.get(`${BASE_URL}/categorias`),

  /**
   * Retorna produtos filtrados por categoria.
   * GET /web/client/catalog/hierarchy/produtos?categoriaId=X
   */
  getProdutosByCategoria: (categoriaId) =>
    axios.get(`${BASE_URL}/produtos`, { params: { categoriaId } }),

  /**
   * Retorna serviços vinculados a um produto.
   * GET /web/client/catalog/hierarchy/servicos?produtoId=Y
   */
  getServicosByProduto: (produtoId) =>
    axios.get(`${BASE_URL}/servicos`, { params: { produtoId } }),

  /**
   * Retorna árvore completa (categoria → produtos → serviços).
   * GET /web/client/catalog/hierarchy/arvore
   */
  getArvoreCompleta: () => axios.get(`${BASE_URL}/arvore`),
};
